
import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Alert } from 'react-bootstrap';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const [statusMessage, setStatusMessage] = useState('');
  const [statusVariant, setStatusVariant] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSending || isSubmitted) return;

    setIsSending(true);
    setStatusMessage('');

    try {
      const response = await fetch(
        'https://war2escape-6b76ef259e96.herokuapp.com/contact',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }
      );

      if (response.status === 429) {
        setStatusMessage(
          'Too many requests. Please try again in 15 minutes.'
        );
        setStatusVariant('danger');
        return;
      }

      if (!response.ok) {
        throw new Error('Failed to send message.');
      }

      setStatusMessage('Message sent successfully!');
      setStatusVariant('success');
      setIsSubmitted(true);

    } catch (error) {
      console.error('Contact form error:', error.message);

      setStatusMessage(
        'There was an error sending your message. Please try again later.'
      );
      setStatusVariant('danger');

    } finally {
      setIsSending(false);
    }
  };

  return (
    <section id="contact" className="contact">
      <Container>
        <Row className="justify-content-center">
          <Col md={8}>
            <h2 className="section-title">Contact Us</h2>

            <p className="section-description">
              If you have any questions, feedback, or need assistance,
              feel free to reach out to us.
            </p>

            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="formName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  maxLength={100}
                  required
                  disabled={isSubmitted || isSending}
                />
              </Form.Group>

              <Form.Group controlId="formEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  maxLength={254}
                  required
                  disabled={isSubmitted || isSending}
                />
              </Form.Group>

              <Form.Group controlId="formSubject">
                <Form.Label>Subject</Form.Label>
                <Form.Control
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  maxLength={150}
                  required
                  disabled={isSubmitted || isSending}
                />
              </Form.Group>

              <Form.Group controlId="formMessage">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  maxLength={3000}
                  required
                  disabled={isSubmitted || isSending}
                />
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                disabled={isSubmitted || isSending}
              >
                {isSubmitted
                  ? 'Submitted'
                  : isSending
                    ? 'Sending...'
                    : 'Submit'}
              </Button>
            </Form>

            {statusMessage && (
              <Alert
                variant={statusVariant}
                onClose={() => setStatusMessage('')}
                dismissible
                className="mt-3"
              >
                {statusMessage}
              </Alert>
            )}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
